import service from './service';
import { UrlBuilder } from './url-builder';

export const notificationList = async (companyId, page, pageSize) => {
  if (!companyId) return [];

  const builder = new UrlBuilder(`companies/${companyId}/emergencies`);

  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const notificationCountByCompany = async (companyId, filter) => {
  if (!companyId) return 0;

  const builder = new UrlBuilder(`/companies/${companyId}/notification/count`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return 0;
};

export const notificationCountByPartner = async (partnerId) => {
  if (!partnerId) return 0;

  const builder = new UrlBuilder(`/partners/${partnerId}/notification/count`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return 0;
};

export const managernotificationList = async (companyId, premiseId, page, pageSize) => {
  if (!companyId) return [];

  const builder = new UrlBuilder(`manager/company/${companyId}/premise/${premiseId}/emergencies`);

  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};
